function displayMask()
{
  hideTargetAndTest();
  maskContainer.className="nonclickableImage";//this modifies a bit position; why?
  maskContainer.style.top = Math.round(halfCanvasHeight - imageMaskHeight/2 - borderImage) + "px";
  maskContainer.style.left = Math.round(halfCanvasWidth - imageMaskWidth/2 - borderImage) + "px";
  maskContainer.style.display="block";
}